if (!customElements.get('moebe-pair-purchase')) {
  customElements.define('moebe-pair-purchase', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const form = this.querySelector('form');
      const button = form.querySelector('button[type="submit"]');
      const select = form.querySelector('select');
      const message = this.querySelector('[role="status"]');
      const row = this.closest('.moebe-pair');
      if (select) {
        button.disabled = !select.value;
        select.addEventListener('change', () => {
          button.disabled = !select.value;
          message.textContent = '';
          const option = select.selectedOptions[0];
          if (!option || !option.value) return;
          row.querySelector('.moebe-pair__price').textContent = option.dataset.price;
          row.querySelectorAll('a').forEach(link => link.href = option.dataset.url);
          const image = row.querySelector('img');
          if (image && option.dataset.image) {
            image.removeAttribute('srcset');
            image.src = option.dataset.image;
          }
        });
      }
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (this.busy || !form.reportValidity()) return;
        this.busy = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        message.textContent = '';
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: new FormData(form)
          });
          const result = await response.json();
          if (!response.ok || result.status >= 400) {
            throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
          }
          message.textContent = this.dataset.added;
          form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            bubbles: true,
            detail: { product: result, addToCartBtn: button }
          }));
        } catch (error) {
          message.textContent = error instanceof TypeError ? this.dataset.error : (error.message || this.dataset.error);
        } finally {
          this.busy = false;
          button.disabled = select ? !select.value : false;
          button.removeAttribute('aria-busy');
        }
      });
    }
  });
}
